import {createTheme} from '@mui/material/styles'

const ThemeMui = ({primaryColor, secundaryColor, bodyColor, textBodyColor}) => createTheme({
    palette: {
        primary: {
            main: primaryColor,
        },
        secondary: {
            main: secundaryColor
        }
    },
    components: {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: bodyColor,
                    borderRadius: 30,
                    padding: 20
                }
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: bodyColor,
                    color: textBodyColor,
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    color: textBodyColor,
                    padding: 10,
                    userSelect: 'none'
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: 10,
                    overflowY: 'auto',
                    '::-webkit-scrollbar': {display: 'none'},
                    '-ms-overflow-style': 'none',
                    'scrollbar-width': 'none',
                },
            },
        },
        MuiDialogContentText: {
            styleOverrides: {
                root: {
                    color: textBodyColor,
                    userSelect: 'none'
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: bodyColor
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    borderRadius: 50,
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    color: textBodyColor,
                    borderRadius: 10,
                    "&.Mui-disabled": {
                        backgroundColor: "#f5f5f5",
                        color: "#888",
                    }
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: 'Nunito'
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    zIndex: 0
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    userSelect: 'none'
                },
            },
        }
    },
});

export default ThemeMui
